import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {
    AVAILABLE_LOCALES,
    FALLBACK_LOCALE,
    LOCALE_COOKIE_NAME,
    pluralizationRule,
} from '@/i18n/config';
import kk from '@/i18n/locales/kk';
import ru from '@/i18n/locales/ru';
import { getCookie } from '@/utils/cookie';

Vue.use(VueI18n);

/**
 * Язык из куки, если он доступен, иначе язык по умолчанию
 *
 * @return {String}
 */
const getInitialLocale = (): string => {
    const cookieLocale = getCookie(LOCALE_COOKIE_NAME);

    return cookieLocale && AVAILABLE_LOCALES.includes(cookieLocale)
        ? cookieLocale
        : FALLBACK_LOCALE;
};

export const i18n = new VueI18n({
    fallbackLocale: FALLBACK_LOCALE,
    locale:         getInitialLocale(),
    messages:       { kk, ru },
    missing(locale, key) {
        console.warn(`[vue-i18n] Fail: locale="${locale}" key="${key}"`);
    },
    pluralizationRules: { ru: pluralizationRule },
});

document.documentElement.lang = i18n.locale;
